import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import {
  filterTornOptions,
  filterUnknownOptions
} from "../../../../services/device-container-state-controller.service";
import { FilterControlComponent } from "../../../elements/filter-control/filter-control.component";

@Component({
  selector: "app-header-kpi",
  templateUrl: "./header-kpi.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./header-kpi.component.scss"],
  imports: [FilterControlComponent]
})
export class HeaderKpiComponent {
  @Output() containers: EventEmitter<string[]> = new EventEmitter();
  @Output() torn: EventEmitter<string> = new EventEmitter();
  @Output() unknown: EventEmitter<string> = new EventEmitter();
  @Output() devicesTypes: EventEmitter<string[]> = new EventEmitter();
  @Output() containerCategory: EventEmitter<string[]> = new EventEmitter();

  @Input() filterContainers: string[] = [];
  @Input() filterTorn: string;
  @Input() filterUnknown: string;
  @Input() filterDevicesTypes: string[] = [];
  @Input() filterContainerCategory: string[] = [];

  public tornFilterOptions: string[] = Object.keys(filterTornOptions);
  public unknownFilterOptions: string[] = Object.keys(filterUnknownOptions);

  constructor() {}

  public manageContainers(containers): void {
    this.containers.emit(containers);
  }

  public manageTorn(torn: string): void {
    this.torn.emit(torn);
  }

  public manageUnknown(unknown: string): void {
    this.unknown.emit(unknown);
  }

  public manageDevicesTypes(devicesTypes: string[]): void {
    this.devicesTypes.emit(devicesTypes);
  }

  public manageContainerCategory(categories: string[]): void {
    this.containerCategory.emit(categories);
  }
}
